import { axiosLasta } from 'config';
import { CACHE_NAME_ORGANIZATION_LIST } from 'services/constants/cacheNameConstants';

export const getAllOrganizationList = async (forceRefresh = false) => {
    const response = await axiosLasta.get('/organization/all', {
        cache: forceRefresh ? { enabled: false } : { enabled: true, key: CACHE_NAME_ORGANIZATION_LIST },
    });
    return response?.data;
};

export const getOrganizationListForCurrentUser = async (locationId) => {
    const response = await axiosLasta.get(`/organization/location/${locationId}/current-user`);
    return response?.data;
};

export const searchOrganizationByName = async ({ name }) => {
    const response = await axiosLasta.get('/organization/search', {
        params: {
            name: name,
            limit: 100,
        },
        cache: {
            enabled: true,
            key: `organization/search?name=${name}&limit=100`,
        },
    });
    return response?.data;
};

export const createOrganization = async (payload) => {
    const response = await axiosLasta.post('/organization', payload, {
        cache: {
            prune: [CACHE_NAME_ORGANIZATION_LIST],
        },
    });
    return response?.data;
};

export const updateOrganization = async (payload) => {
    const response = await axiosLasta.put('/organization', payload, {
        cache: {
            prune: [CACHE_NAME_ORGANIZATION_LIST],
        },
    });
    return response?.data;
};

export const fetchOrganizationLocationsByOrganizationId = async (id) => {
    const response = await axiosLasta.get(`/location/organization/${id}`, {
        params: {
            status: true,
        },
    });
    return response?.data;
};

export const fetchOrganizationById = async (organizationId) => {
    const response = await axiosLasta(`/organization/id/${organizationId}`);
    return response?.data;
};
